import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const StyledButton = styled(Button)<{ isDisabled?: boolean }>`
    ${({ isDisabled }) =>
        setFontVariant("button", isDisabled ? colorsPalettes.carbon["200"] : colorsPalettes.blue["400"])}
`;
